module.exports = __webpack_public_path__ + "img/group.8380c839.svg";